import checkoutPageActionTypes from './actionTypes';
// @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
import createReducer from '../../util/createReducer';
import _ from 'lodash';

const INITIAL_STATE = {
  isFetching: false,
  isLoadingPaymentForm: false,
  error: null,
  friendlyErrorMessage: null,
  response: null,
  subscription: null,
  currentStep: 'hide-prices',
  account: null,
  selectedOption: null,
};

const reducer = createReducer(INITIAL_STATE, {
  [checkoutPageActionTypes.SHOW_PRICES]: (state: any) => {
    return {
      ...state,
      isFetching: false,
      error: null,
      currentStep: null,
    };
  },
  [checkoutPageActionTypes.START_CHECKOUT]: (state: any) => {
    return {
      ...state,
      isFetching: false,
      error: null,
      currentStep: 'account-info',
    };
  },
  [checkoutPageActionTypes.CREATE_CHECKOUT_PAGE_START]: (state: any) => {
    return {
      ...state,
      isFetching: true,
      error: null,
      response: null,
      friendlyErrorMessage: null,
    };
  },
  [checkoutPageActionTypes.CREATE_CHECKOUT_PAGE_SUCCESS]: (
    state: any,
    action: any,
  ) => {
    return {
      ...state,
      isFetching: false,
      error: null,
      response: action.response,
      currentStep: 'payment-info',
      isLoadingPaymentForm: true,
    };
  },
  [checkoutPageActionTypes.CREATE_CHECKOUT_PAGE_ERROR]: (
    state: any,
    action: any,
  ) => {
    const statusCode = _.get(action, 'status', 0);
    const friendlyErrorMessage =
      statusCode === 400 ? _.get(action, 'response.error', null) : null;

    return {
      ...state,
      isFetching: false,
      error: action.error,
      friendlyErrorMessage,
      response: null,
      isLoadingPaymentForm: false,
    };
  },
  [checkoutPageActionTypes.CHECKOUT_START]: (state: any) => {
    return {
      ...state,
      isFetching: true,
    };
  },
  [checkoutPageActionTypes.CHECKOUT_PAGE_LOADED]: (state: any) => {
    return {
      ...state,
      isFetching: false,
      isLoadingPaymentForm: false,
    };
  },
  [checkoutPageActionTypes.CHECKOUT_SUCCESS]: (state: any) => {
    return {
      ...state,
      isFetching: false,
      currentStep: 'checkout-success',
    };
  },
  [checkoutPageActionTypes.CHECKOUT_FAIL]: (state: any, action: any) => {
    return {
      ...state,
      isFetching: false,
      error: action.error,
      currentStep: 'checkout-error',
    };
  },
  [checkoutPageActionTypes.CHECKOUT_FINALIZATION_SUCCESS]: (
    state: any,
    action: any,
  ) => {
    return {
      ...state,
      isFetching: false,
      currentStep: 'checkout-finalization-success',
      subscription: action.response,
    };
  },
  [checkoutPageActionTypes.CHECKOUT_FINALIZATION_ERROR]: (
    state: any,
    action: any,
  ) => {
    return {
      ...state,
      isFetching: false,
      error: action.error,
      currentStep: 'checkout-finalization-error',
    };
  },
  [checkoutPageActionTypes.CHECKOUT_RESET]: () => {
    return INITIAL_STATE;
  },
  [checkoutPageActionTypes.CHECKOUT_PAGE_SET_ACCOUNT]: (
    state: any,
    action: any,
  ) => {
    return {
      ...state,
      account: action.account,
    };
  },
  [checkoutPageActionTypes.CHECKOUT_PAGE_SET_SELECT_OPTION]: (
    state: any,
    action: any,
  ) => {
    return {
      ...state,
      selectedOption: action.selectedOption,
    };
  },
});

export default reducer;
